export const productScentMapping: {
  [regularProductId: number]: {
    upgradeProductId: number;
    variants: { [ultrawashVariantId: number]: number };
  };
} = {
  // Ultrawash, Fresh Rain -> Ultrawash Plus, Lemon Citrus
  6763008163939: {
    upgradeProductId: 7641731432547, // Ultrawash Plus product ID
    variants: {
      // Ultrawash -> Ultrawash Plus variants
      39883806965859: 42822061064291, // 64 ct
      42660165451875: 42822061097059, // 128 ct
      42660165484643: 42822061129827, // 192 ct
    },
  },
  // Ultrawash, Lemon Citrus -> Ultrawash Plus, Lemon Citrus
  9913947474: {
    upgradeProductId: 7641731432547, // Ultrawash Plus product ID
    variants: {
      // Ultrawash -> Ultrawash Plus variants
      37970405074: 42822061064291, // 64 ct
      42660163551331: 42822061097059, // 128 ct
      42660163584099: 42822061129827, // 192 ct
    },
  },
  // Ultrawash, Unscented -> Ultrawash Plus, Unscented
  781111296099: {
    upgradeProductId: 7641733234787, // Ultrawash Plus product ID
    variants: {
      // Ultrawash -> Ultrawash Plus variants
      8734060249187: 42842331676771, // 64 ct
      42660164468835: 42842331709539, // 128 ct
      42660164501603: 42842331742307, // 192 ct
    },
  },
};
